import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicMerge({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.75 1.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H11.5v1.25c0 .92-.7 1.67-1.6 1.74l-.15.01h-6.5c-.92 0-1.67-.7-1.74-1.6l-.01-.15v-6.5c0-.92.7-1.67 1.6-1.74l.15-.01H4.5V3.25c0-.92.7-1.67 1.6-1.74l.15-.01zM4.5 6H3.25a.25.25 0 00-.24.2L3 6.24v6.5c0 .12.08.22.2.24l.05.01h6.5c.12 0 .22-.08.24-.2l.01-.05V11.5H6.25c-.92 0-1.67-.7-1.74-1.6l-.01-.15V6zm8.25-3h-6.5a.25.25 0 00-.25.25v6.5c0 .14.11.25.25.25h6.5c.14 0 .25-.11.25-.25v-6.5a.25.25 0 00-.25-.25z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicMerge.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicMerge.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicMerge svgRef={ref} {...props} />);
export default ForwardRef;
